export const MIN_PRIORITY = 1;
export const MAX_PRIORITY = 10;

export const DISABLE_CAMPAIGN_PRIORITY_END_DATE =
  'Campaign priority can’t be added without the IO end date.';

export const DEFAULT_ACTIVE_PRIORITY = 2147483647;
